import { createFeatureSelector, createSelector } from '@ngrx/store';
import { appKey } from '../reducers/app.reducers';
import { AppState } from '../states/app.states';

export const selectAppState = createFeatureSelector<AppState>(appKey);

